<template>
  <teleport to="body">
    <div class="fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none">
      <transition-group name="toast">
        <div
          v-for="msg in messages"
          :key="msg.id"
          class="pointer-events-auto flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg text-sm font-medium min-w-[240px] max-w-[360px]"
          :class="{
            'bg-success text-white':  msg.type === 'success',
            'bg-danger text-white':   msg.type === 'error',
            'bg-warning text-white':  msg.type === 'warning',
            'bg-primary text-white':  msg.type === 'info',
          }"
        >
          <span class="flex-1">{{ msg.text }}</span>
          <button class="opacity-60 hover:opacity-100" @click="remove(msg.id)">✕</button>
        </div>
      </transition-group>
    </div>
  </teleport>
</template>

<script setup>
import { messages, remove } from '@/services/toast.js'
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.25s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateX(1rem);
}
.toast-leave-to {
  opacity: 0;
  transform: translateX(1rem);
}
</style>
